export default [ 'begins-with', 'ends-with', 'does-not-begin-with', 'does-not-end-with' ]
